export const viewsEnum={
    CONTACT: 'contact',
    LANDING: 'landing',
    COOKIE: 'cookie',
    SOLTUIONS: 'solutions'
}